// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AssetBalanceItemColumnsEnum } from '../Enums/AccountDetailsEnum';
export const GROUP = {
    GENERAL: 'FUNCTION_ACCOUNT_DETAILS_GENERAL',
    MARGIN: 'FUNCTION_ACCOUNT_DETAILS_MARGIN',
    ACCOUNT_ACTIVITY: 'FUNCTION_ACCOUNT_DETAILS_ACCOUNT_ACTIVITY',
    TODAY_RESULTS: 'FUNCTION_ACCOUNT_DETAILS_TODAY_RESULTS',
    RISK_MANAGEMENT: 'FUNCTION_ACCOUNT_DETAILS_RISK_MANAGEMENT',
    INFO: 'FUNCTION_ACCOUNT_DETAILS_INFO'
};
export const ACCOUNT_COLUMN_RULE = new Map([
    [AssetBalanceItemColumnsEnum.BALANCE_COL_INDEX, { rule: 'FUNCTION_ACCOUNT_DETAILS_BALANCE', group: GROUP.GENERAL }],
    [
        AssetBalanceItemColumnsEnum.PROJECTED_BALANCE_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_PROJECTED_BALANCE', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.BALANCE_PLUS_ALL_RISKS_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_BALANCE_RISKS', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.CREDIT_VALUE_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_CREDIT_VALUE', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.AVAILABLE_FUNDS_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_AVAILABLE_FUNDS', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.BLOCKED_BALANCE_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_BLOCKED_BALANCE', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.CASH_BALANCE_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_CASH_BALANCE', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.UNSETTLED_CASH_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_UNSETTLED_CASH', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.WITHDRAWAL_AVAILABLE_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_WITHDRAWAL_AVAILABLE', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.INTEREST_RATE_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_INTEREST_RATE', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.NEGATIVE_INTEREST_RATE_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_INTEREST_RATE', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.STOCKS_VALUE_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_STOCKS_VALUE', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.OPTION_VALUE_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_OPTION_VALUE', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.STOCKS_LIQUIDITY_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_STOCKS_LIQUIDITY', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.COLLATERAL_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_COLLATERAL', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.INCOMING_FUNDS_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_INCOMING_FUNDS', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.AVAILABLE_CASH_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_AVAILABLE_CASH', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.FIXED_INCOME_VALUE,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_FIXED_INCOME_VALUE', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.FREE_COMMISSION_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_FREE_COMMISSION', group: GROUP.GENERAL }
    ],
    [
        AssetBalanceItemColumnsEnum.INITIAL_MARGIN_REQ_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_INITIAL', group: GROUP.MARGIN }
    ],
    [
        AssetBalanceItemColumnsEnum.INITIAL_MARGIN_REQ_PERCENT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_INITIAL_PERCENT', group: GROUP.MARGIN }
    ],
    [
        AssetBalanceItemColumnsEnum.TOTAL_MAINT_REQ_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_MAINTENANCE', group: GROUP.MARGIN }
    ],
    [
        AssetBalanceItemColumnsEnum.MAINTENANCE_MARGIN_REQ_PERCENT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_MAINTENANCE_PERCENT', group: GROUP.MARGIN }
    ],
    [
        AssetBalanceItemColumnsEnum.WARNING_MARGIN_REQ_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_WARNING', group: GROUP.MARGIN }
    ],
    [
        AssetBalanceItemColumnsEnum.WARNING_MARGIN_REQ_PERCENT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_WARNING_PERCENT', group: GROUP.MARGIN }
    ],
    [
        AssetBalanceItemColumnsEnum.MARGIN_BEFORE_WARNING_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_MARGIN_BEFORE_WARNING', group: GROUP.MARGIN }
    ],
    [
        AssetBalanceItemColumnsEnum.MARGIN_AVAILABLE_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_MARGIN_AVAILABLE', group: GROUP.MARGIN }
    ],
    [
        AssetBalanceItemColumnsEnum.MARGIN_WARN_PERCENT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_MARGIN_WARNING_LEVEL', group: GROUP.MARGIN }
    ],
    [
        AssetBalanceItemColumnsEnum.MARGIN_WARNING_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_WARNING_MARGIN', group: GROUP.MARGIN }
    ],
    [
        AssetBalanceItemColumnsEnum.BLOCKED_FOR_STOCKS_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_BLOCKED_FOR_STOCKS', group: GROUP.MARGIN }
    ],
    [
        AssetBalanceItemColumnsEnum.STOCKS_ORDERS_REQ_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_STOCK_ORDERS_REQ', group: GROUP.MARGIN }
    ],
    [
        AssetBalanceItemColumnsEnum.STOP_OUT_LEVEL_PERCENT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_STOP_OUT_LEVEL', group: GROUP.MARGIN }
    ],
    [
        AssetBalanceItemColumnsEnum.OPTION_PREMIUM_REQ_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_OPTION_PREMIUM_REQ', group: GROUP.MARGIN }
    ],
    [
        AssetBalanceItemColumnsEnum.WAIVED_MARGIN_AMOUNT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_WAIVED_MARGIN', group: GROUP.MARGIN }
    ],
    [
        AssetBalanceItemColumnsEnum.INITIAL_MARGIN_WITHOUT_WAIVED_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_INITIAL_WITHOUT_WAIVED', group: GROUP.MARGIN }
    ],
    [
        AssetBalanceItemColumnsEnum.BLOCKED_FOR_FIXED_INCOME,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_BLOCKED_FOR_FIXED_INCOME', group: GROUP.MARGIN }
    ],
    [
        AssetBalanceItemColumnsEnum.FIXED_INCOME_ORDERS_REQ,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_FIXED_INCOME_ORDERS_REQ', group: GROUP.MARGIN }
    ],
    [AssetBalanceItemColumnsEnum.OWNER_COL_INDEX, { rule: 'FUNCTION_ACCOUNT_DETAILS_OWNER', group: GROUP.INFO }],
    [AssetBalanceItemColumnsEnum.USER_ID_COL_INDEX, { rule: 'FUNCTION_ACCOUNT_DETAILS_USER_ID', group: GROUP.INFO }],
    [
        AssetBalanceItemColumnsEnum.USER_LOGIN_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_USER_LOGIN', group: GROUP.INFO }
    ],
    [
        AssetBalanceItemColumnsEnum.USER_GROUP_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_USER_GROUP', group: GROUP.INFO }
    ],
    [AssetBalanceItemColumnsEnum.EMAIL_COL_INDEX, { rule: 'FUNCTION_ACCOUNT_DETAILS_EMAIL', group: GROUP.INFO }],
    [AssetBalanceItemColumnsEnum.ACCOUNT_COL_INDEX, { rule: 'FUNCTION_ACCOUNT_DETAILS_ACCOUNT', group: GROUP.INFO }],
    [
        AssetBalanceItemColumnsEnum.ACCOUNT_TYPE_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_ACCOUNT_TYPE', group: GROUP.INFO }
    ],
    [
        AssetBalanceItemColumnsEnum.ACCOUNT_MODE_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_ACCOUNT_MODE', group: GROUP.INFO }
    ],
    [
        AssetBalanceItemColumnsEnum.TERMINAL_TYPE_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_TERMINAL_TYPE', group: GROUP.INFO }
    ],
    [AssetBalanceItemColumnsEnum.STATUS_COL_INDEX, { rule: 'FUNCTION_ACCOUNT_DETAILS_STATUS', group: GROUP.INFO }],
    [
        AssetBalanceItemColumnsEnum.TELEPHONE_NUMBER_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_TELEPHONE', group: GROUP.INFO }
    ],
    [AssetBalanceItemColumnsEnum.ASSET_NAME_COL_INDEX, { rule: 'FUNCTION_ACCOUNT_DETAILS_ASSET', group: GROUP.INFO }],
    [
        AssetBalanceItemColumnsEnum.ASSET_DESCRIPTION_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_ASSET_DESCRIPTION', group: GROUP.INFO }
    ],
    [
        AssetBalanceItemColumnsEnum.ASSET_TYPE_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_ASSET_TYPE', group: GROUP.INFO }
    ],
    [
        AssetBalanceItemColumnsEnum.POWER_OF_ATTORNEY_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_POA', group: GROUP.INFO }
    ],
    [
        AssetBalanceItemColumnsEnum.LOCKED_STATUS_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_LOCKED_BY', group: GROUP.INFO }
    ],
    [AssetBalanceItemColumnsEnum.FUND_TYPE_COL_INDEX, { rule: 'FUNCTION_ACCOUNT_DETAILS_ROLE', group: GROUP.INFO }],
    [
        AssetBalanceItemColumnsEnum.COMMISSIONS_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_COMMISSIONS', group: GROUP.INFO }
    ],
    [AssetBalanceItemColumnsEnum.SWAP_COL_INDEX, { rule: 'FUNCTION_ACCOUNT_DETAILS_SWAPS', group: GROUP.INFO }],
    [AssetBalanceItemColumnsEnum.SPREADS_COL_INDEX, { rule: 'FUNCTION_ACCOUNT_DETAILS_SPREADS', group: GROUP.INFO }],
    [AssetBalanceItemColumnsEnum.MARKUPS_COL_INDEX, { rule: 'FUNCTION_ACCOUNT_DETAILS_MARKUPS', group: GROUP.INFO }],
    [
        AssetBalanceItemColumnsEnum.INSERT_ON_BALANCE_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_INTEREST_ON_BALANCE', group: GROUP.INFO }
    ],
    [
        AssetBalanceItemColumnsEnum.MARGIN_AND_RISKS_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_MARGIN_AND_RISKS', group: GROUP.INFO }
    ],
    [
        AssetBalanceItemColumnsEnum.PROFIT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_OPEN_GROSS_PNL', group: GROUP.ACCOUNT_ACTIVITY }
    ],
    [
        AssetBalanceItemColumnsEnum.PROFIT_NET_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_OPEN_NET_PNL', group: GROUP.ACCOUNT_ACTIVITY }
    ],
    [
        AssetBalanceItemColumnsEnum.POSITIONS_COUNT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_POSITIONS', group: GROUP.ACCOUNT_ACTIVITY }
    ],
    [
        AssetBalanceItemColumnsEnum.ORDERS_COUNT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_ORDERS', group: GROUP.ACCOUNT_ACTIVITY }
    ],
    [
        AssetBalanceItemColumnsEnum.TOTAL_POSITIONS_VALUE_COL_INDEX,
        { rule: 'FUNCTION_TOTAL_POSITIONS_VALUE', group: GROUP.ACCOUNT_ACTIVITY }
    ],
    [
        AssetBalanceItemColumnsEnum.TODAY_GROSS_PNL_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_TODAYS_GROSS', group: GROUP.TODAY_RESULTS }
    ],
    [
        AssetBalanceItemColumnsEnum.TODAY_REALIZED_PNL_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_TODAYS_NET', group: GROUP.TODAY_RESULTS }
    ],
    [
        AssetBalanceItemColumnsEnum.TODAY_FEES_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_TODAYS_FEES', group: GROUP.TODAY_RESULTS }
    ],
    [
        AssetBalanceItemColumnsEnum.TODAY_VOLUME_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_TODAYS_VOLUME', group: GROUP.TODAY_RESULTS }
    ],
    [
        AssetBalanceItemColumnsEnum.TODAY_TRADES_COUNT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_TODAYS_TRADES', group: GROUP.TODAY_RESULTS }
    ],
    [
        AssetBalanceItemColumnsEnum.TODAY_REBATES_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_TODAYS_REBATES', group: GROUP.TODAY_RESULTS }
    ],
    [
        AssetBalanceItemColumnsEnum.TODAY_SWAPS_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_TODAYS_SWAPS', group: GROUP.TODAY_RESULTS }
    ],
    [
        AssetBalanceItemColumnsEnum.TRADING_STATUS_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_TRADING_STATUS', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.DAILY_LOSS_LIMIT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_DAILY_LOSS_LIMIT', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.CURRENT_DAILY_LOSS_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_DAILY_LOSS', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.MAX_WEEKLY_LOSS_LIMIT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_WEEKLY_LOSS_LIMIT', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.CURRENT_WEEKLY_LOSS_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_WEEKLY_LOSS', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.TRAILING_DRAWDOWN_LEVEL_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_TRAILING_DRAWDOWN', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.MAX_ORDERS_PER_DAY_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_MAX_ORDER_COUNT', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.MAX_POSITIONS_COUNT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_MAX_POSITIONS', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.MAX_PENDING_ORDERS_COUNT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_MAX_PENDING_ORDERS', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.MAX_ORDER_CAPITAL_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_MAX_ORDER_CAPITAL', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.MAX_DRAWDOWN_LEVEL_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_MAX_DRAWDOWN', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.MAX_RELATIVE_DRAWDOWN_LEVEL_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_MAX_RELATIVE_DRAWDOWN', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.MAX_ORDER_AMOUNT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_MAX_ORDER_AMOUNT', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.UNREALIZED_PL_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_UNREALIZED_LOSS', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.UNREALIZED_LOSS_LIMIT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_UNREALIZED_LOSS_LIMIT', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.DAILY_PROFIT_TARGET_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_DAILY_PROFIT_TARGET', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.TOTAL_MAX_POSITIONS_COUNT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_TOTAL_MAX_POSITION', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.DAY_TRADER_PATTERN_PROTECTION_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_DAY_TRADER_PATTERN', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.AVAILABLE_DAY_TRADES_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_AVAILABLE_DAY_TRADES', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.LOSS_LIMIT_PER_TRADE_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_LOSS_LIMIT_PER_TRADES', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.MAX_RELATIVE_DAILY_LOSS_LIMIT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_MAX_RELATIVE_DAILY_LOSS_LIMIT', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.EOD_TRAILING_DRAWDOWN_LEVEL_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_EOD_TRAILING_DRAWDOWN', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.EQUITIES_VOLUME_LIMIT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_EQUITIES_VOLUME_LIMIT', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.FUTURES_VOLUME_LIMIT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_EQUITIES_VOLUME_LIMIT', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.OPTIONS_VOLUME_LIMIT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_EQUITIES_VOLUME_LIMIT', group: GROUP.RISK_MANAGEMENT }
    ],
    [
        AssetBalanceItemColumnsEnum.TOTAL_VOLUME_LIMIT_COL_INDEX,
        { rule: 'FUNCTION_ACCOUNT_DETAILS_EQUITIES_VOLUME_LIMIT', group: GROUP.RISK_MANAGEMENT }
    ]
]);
